import { render, staticRenderFns } from "./ElectronicaBanner.vue?vue&type=template&id=03a834de&scoped=true"
import script from "./ElectronicaBanner.vue?vue&type=script&lang=js"
export * from "./ElectronicaBanner.vue?vue&type=script&lang=js"
import style0 from "./ElectronicaBanner.vue?vue&type=style&index=0&id=03a834de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03a834de",
  null
  
)

export default component.exports